import { useEffect } from "react";
import axios from "axios";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

const CourseSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const sessionId = searchParams.get("session_id");
  const courseId = searchParams.get("course_id");
  // const studentEmail = searchParams.get("user_email");
  const student_email = localStorage.getItem("user_email");

  const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";

  useEffect(() => {
    const handleSuccess = async () => {
      if (!sessionId) {
        navigate("/codegenie/generated-courses");
        return;
      }

      try {
        await axios.get(`${apiUrl}/api/subscription/course-order-success`, {
          params: {
            session_id: sessionId,
            course_id: courseId,
            student_email: student_email,
          },
        });

        /* setTimeout(() => {
          navigate("/codegenie/course-detail", {
            state: { courseId: courseId },
          });
        }, 2000); */
        setTimeout(() => {
          navigate("/codegenie/course-thankyou", {
            state: {
              courseId,
            },
          });
        }, 1500);
      } catch (error) {
        console.error("Course success error", error);
        navigate("/codegenie/generated-blogs");
      }
    };

    handleSuccess();
  }, [sessionId, navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <CircularProgress />

      <Typography fontSize="20px" fontWeight={500}>
        Redirecting...
      </Typography>
    </Box>
  );
};

export default CourseSuccess;
